import name from './name'

const selectSliceData = state => state[name]

const selectSkillBite = state => selectSliceData(state).skillBite

const selectReminderDate = state => selectSliceData(state).reminderDate

export { selectSkillBite, selectReminderDate }
